import { z } from 'zod';

export const ContentTypeEnumSchema = z.enum([
    'text/plain',
    'text/markdown',
    'application/json',
    'application/vnd.amazonaws.connect.message.interactive.response',
    'application/vnd.amazonaws.connect.event.chat.rehydrated',
    'application/vnd.amazonaws.connect.event.typing',
    'application/vnd.amazonaws.connect.event.message.read',
    'application/vnd.amazonaws.connect.event.message.delivered',
    'application/vnd.amazonaws.connect.event.participant.joined',
    'application/vnd.amazonaws.connect.event.participant.left',
    'application/vnd.amazonaws.connect.event.participant.returned',
    'application/vnd.amazonaws.connect.event.transfer.succeeded',
    'application/vnd.amazonaws.connect.event.transfer.failed',
    'application/vnd.amazonaws.connect.message.interactive',
    'application/vnd.amazonaws.connect.event.chat.ended',
    'application/vnd.amazonaws.connect.event.participant.autodisconnection',
    'application/vnd.amazonaws.connect.event.participant.idle',
    'application/vnd.amazonaws.connect.event.message.read',
    'application/vnd.amazonaws.connect.event.message.delivered',
    'application/vnd.amazonaws.connect.event.message.metadata',
]);

export const JsonContentTypeEnumSchema = z.enum([
    'application/sherlock.event.session.started',
    'application/sherlock.event.session.ended',
    'application/sherlock.event.feedback.requested',
    'application/sherlock.event.feedback.thumbs.up',
    'application/sherlock.event.feedback.thumbs.down',
    'application/sherlock.event.end.request',
    'application/sherlock.message.bedrock.response',
]);

export const CampaignEnumSchema = z.enum([
    'RC3',
    'RC3_uk',
    'ACEC_SOCIAL',
    'ACEC_THEFT',
    'ACEC_Ring_Intercom_UK',
    'ACEC_Ring_Intercom_IT',
    'ACEC_Ring_Intercom_NL',
    'ACEC_Ring_Intercom_ES',
    'ACEC_Ring_Intercom_FR',
    'ACEC_Ring_Intercom_DE',
    'ACEC_DE',
    'ACEC_FR',
    'ACEC_IT',
    'ACEC_NL',
    'ACEC_UK',
    'ACEC_ES',
    'ACEC_JP',
    'ACEC_US',
]);
